import { BookOpen, Zap, Globe2 } from "lucide-react";
import type { LucideProps } from "lucide-react";
import type { ForwardRefExoticComponent, RefAttributes } from "react";

export type LucideIcon = ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>;

export interface Milestone {
  id: number;
  icon: LucideIcon;
  title: string;
  description: string;
  color: string;
  glowColor: string;
  highlighted?: boolean;
}

export const milestones: Milestone[] = [
  {
    id: 1,
    icon: BookOpen,
    title: "Learn English",
    description: "You already have an intermediate or advanced level of English — from any native language.",
    color: "from-blue-500 to-cyan-600",
    glowColor: "rgba(59, 130, 246, 0.3)"
  },
  {
    id: 2,
    icon: Zap,
    title: "Work with International Teams",
    description: "You already use some English at work, but still hesitate to have deeper discussions, lead or speak up.",
    color: "from-primary to-accent",
    glowColor: "rgba(147, 51, 234, 0.4)"
  },
  {
    id: 3,
    icon: Globe2,
    title: "The Last Mile — GlobalCoders",
    description: "Turn good English into career confidence. Speak, present, and lead with ease.",
    color: "from-emerald-500 to-teal-600",
    glowColor: "rgba(16, 185, 129, 0.3)",
    highlighted: true
  }
];
